import './App.css';
import PdfChatApp from './Components/PdfChatApp';
// import { pdfjs } from 'react-pdf';

// // Set the pdfjs worker to avoid the API version mismatch warning
// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@2.10.377/es5/build/pdf.worker.min.js`;
function App() {
  return (
<>
<PdfChatApp/>
</>
  );
}

export default App;
